<template>
  <a-col :sm="{span:24}" :md="{span:24}" :lg="{span:12}" :xl="{span:12}" :xxl="{span:12}" class="assign-admin reviewers-section">
    <a-card :title="reviewerNameLabel" :style="{ marginTop: '16px', minHeight: '240px'}">
    <template #extra>
          <div class="assessment-status"
        v-if="isCurrentReviewerAssigned === 'yes' && !reAssignFlag">
        
          <a-tag color="red" v-if="assignedAssessmentStatus
                      === 'assigned'">
            <router-link :to="{
                    name: 'assessment-details',
                    params: {
                      assessmentId: assessmentId,
                    }
                    }">Assigned        </router-link>

          </a-tag>
        
          <a-tag color="cyan" v-if="assignedAssessmentStatus
                    === 'in_progress'">
            <router-link :to="{
                    name: 'assessment-details',
                    params: {
                      assessmentId: assessmentId,
                    }
                    }">In-progress        </router-link>
          </a-tag>

        
          <a-tag color="green" v-if="assignedAssessmentStatus
                    === 'completed'">
            <router-link :to="{
                    name: 'assessment-details',
                    params: {
                      assessmentId: assessmentId,
                    }
                    }">Completed        </router-link>
          </a-tag>

      </div>
      <div class="assessment-status" v-else>
        <a-tag color="orange">
          Not Assigned
        </a-tag>
      </div>
    </template>
      <div class="reviewer-name"
        v-if="isCurrentReviewerAssigned === 'no' || reAssignFlag">
        <label v-html="reviewerNameLabel"/>
        <a-select
          showSearch
          mode="default"
          labelInValue
          :value="reviewerValue"
          placeholder="Search..."
          style="width: 50%"
          :filterOption="false"
          @search="fetchReviewer"
          @change="ReviewerChange"
          :notFoundContent="fetchingReviewer ? 'Searching' : 'Not Found'"
          :disabled="isSearchDisabled"
          >
          <a-spin v-if="fetchingReviewer" slot="notFoundContent" size="small" />
            <a-select-option v-for="d in reviewerUserData" :key="d.value">{{d.text.trim()}}
          </a-select-option>
        </a-select>
        <a-button type="dashed" :style="{ float: 'right', marginTop: '20px' }"
          @click="assignAssessor(reviewerValue, reviewerLevel)"
          v-if="Object.entries(reviewerValue).length > 0">
          Assign
        </a-button>
      </div>
      <div class="reviewer-name"
        v-if="isCurrentReviewerAssigned === 'yes' && !reAssignFlag">
        <label v-html="reviewerNameLabel+' Name'"/>
        <router-link :to="{
                  name: 'user-profile',
                  params: {
                    userId: assignedReviewerUserId
                  }
                  }">
          <span v-html="assignedReviewerName"></span>
        </router-link>
      </div>
      <div class="assigned-date">
        <label>Assigned Date:</label>
        <span
          v-if="assignedDate !== 'none' && !reAssignFlag">{{assignedDate | formatDate}}</span>
        <span v-else>---</span>
      </div>
      <div class="commencement-date">
        <label> Commencement Date:</label>
        <span
          v-if="commencementDate !== 'none' ">{{commencementDate | formatDate}}</span>
        <span v-else>---</span>
      </div>
      <div class="completion-date">
        <label>Completion Date:</label>
        <span
          v-if="completionDate !== 'none' ">{{completionDate | formatDate}}</span>
        <span v-else>---</span>
      </div>
      <div class="re-assign-reviewer" v-if="assignedAssessmentStatus === 'in-progress' || assignedAssessmentStatus === 'assigned'">
        <a-button type="dashed" :style="{ float: 'right', marginTop: '20px' }" @click="reAssignFlag ^= true" v-html="reAssignFlag ? 'Cancel' : 'Re-assign'"></a-button>
      </div>
    </a-card>
  </a-col>
</template>
<script>
/* eslint-disable prefer-destructuring */
import { mapActions } from 'vuex';
import baseURL from '@/api/http-common';

export default {
  name: 'assign-reviewer',
  props: [
    'courseDetails',
    'userToken',
    'successMessage',
    'reviewerLevel',
  ],
  data() {
    this.lastFecthedId = 0;
    return {
      reviewerUserData: [],
      reviewerValue: [],
      fetchingReviewer: false,
      localReviewerLevel: '',
      reviewerNameLabel: '',
      isCurrentReviewerAssigned: {},
      assignedReviewerUserId: 0,
      assignedReviewerName: '',
      commencementDate: '',
      assignedDate: '',
      completionDate: '',
      assignedAssessmentStatus: '',
      isSearchDisabled: false,
      reAssignFlag: false,
      canBeReAssigned: true,
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('courses', {
      createAssessment: 'createAssessment',
    }),
    fetchReviewer(value) {
      this.lastFecthedId += 1;
      const fetchId = this.lastFecthedId;
      this.fetchingReviewer = true;
      const userObj = ((localStorage.getItem('telasUserObj') !== null) && (localStorage.getItem('telasUserObj').length > 0)) ? JSON.parse(localStorage.getItem('telasUserObj')) : '';
      const userToken = userObj.token;
      fetch(`${baseURL}wp/v2/users/?search=${value}&roles=telas_assessor&meta[0][key]=telas_assessor_level&meta[0][value]=${this.localReviewerLevel}&meta[1][key]=activated_by_admin&meta[1][value]=yes`, { method: 'GET', headers: { Authorization: `Bearer ${userToken}` } })
        .then(response => response.json())
        .then((body) => {
          if (fetchId !== this.lastFecthedId) { // for fetch callback order
            return;
          }
          const data = body.map(user => ({
            text: `${user.name}`,
            value: String(user.id),
          }));

          this.reviewerUserData = data;
          this.fetchingReviewer = false;
        });
    },
    ReviewerChange(value) {
      this.reviewerValue = value;
    },
    assignAssessor(assessorValue, reviewerLevel) {
      const createAssessmentArgs = {
        ...assessorValue,
        ...{
          courseId: this.$route.params.courseId,
          reviewerLevel,
          userToken: this.userToken,
          reAssign: this.reAssignFlag ? 'yes' : 'no',
        },
      };
      this.createAssessment(createAssessmentArgs);
      this.reAssignFlag = false;
    },
    updateReviewerData() {
      switch (this.reviewerLevel) {
        case 'telas_admin_reviewers':
          this.localReviewerLevel = this.reviewerLevel;
          this.reviewerNameLabel = 'Admin Reviewer';
          this.isCurrentReviewerAssigned = this.courseDetails.assesment_data.is_assigned_admin_reviewer;
          this.assignedReviewerUserId = (this.courseDetails.post_meta !== undefined && this.courseDetails.post_meta.assigned_admin_reviewer_user_id !== undefined) ? this.courseDetails.post_meta.assigned_admin_reviewer_user_id[0] : '';
          this.assignedReviewerName = this.courseDetails.assesment_data.assigned_admin_reviewer_user_display_name;
          this.assignedDate = this.courseDetails.assesment_data.admin_assessment_assigned_date;
          this.commencementDate = this.courseDetails.assesment_data.admin_reviewer_commencement_date;
          this.completionDate = this.courseDetails.assesment_data.admin_reviewer_completion_date;
          this.assessmentId = this.courseDetails.assesment_data.assigned_admin_reviewer_assessment_id;
          this.assignedAssessmentStatus = this.courseDetails.assesment_data.assigned_admin_reviewer_status;
          this.canBeReAssigned = !this.courseDetails.assesment_data.is_assigned_first_reviewer;
          break;
        case 'first_reviewer':
          this.localReviewerLevel = 'telas_certified_reviewers';
          this.reviewerNameLabel = 'First Reviewer';
          this.isCurrentReviewerAssigned = this.courseDetails.assesment_data.is_assigned_first_reviewer;
          this.assignedReviewerUserId = (this.courseDetails.post_meta !== undefined && this.courseDetails.post_meta.assigned_first_reviewer_user_id !== undefined) ? this.courseDetails.post_meta.assigned_first_reviewer_user_id[0] : '';
          this.assignedReviewerName = this.courseDetails.assesment_data.assigned_first_reviewer_user_display_name;
          this.assignedDate = this.courseDetails.assesment_data.first_assessment_assigned_date;
          this.commencementDate = this.courseDetails.assesment_data.first_reviewer_commencement_date;
          this.completionDate = this.courseDetails.assesment_data.first_reviewer_completion_date;
          this.assessmentId = this.courseDetails.assesment_data.assigned_first_reviewer_assessment_id;
          this.assignedAssessmentStatus = this.courseDetails.assesment_data.assigned_first_reviewer_status;
          this.isSearchDisabled = this.courseDetails.assesment_data.assigned_admin_reviewer_status !== 'completed';
          this.canBeReAssigned = !this.courseDetails.assesment_data.is_assigned_second_reviewer;
          break;
        case 'second_reviewer':
          this.localReviewerLevel = 'telas_certified_reviewers';
          this.reviewerNameLabel = 'Second Reviewer';
          this.isCurrentReviewerAssigned = this.courseDetails.assesment_data.is_assigned_second_reviewer;
          this.assignedReviewerUserId = (this.courseDetails.post_meta !== undefined && this.courseDetails.post_meta.assigned_second_reviewer_user_id !== undefined) ? this.courseDetails.post_meta.assigned_second_reviewer_user_id[0] : '';
          this.assignedReviewerName = this.courseDetails.assesment_data.assigned_second_reviewer_user_display_name;
          this.assignedDate = this.courseDetails.assesment_data.second_assessment_assigned_date;
          this.commencementDate = this.courseDetails.assesment_data.second_reviewer_commencement_date;
          this.completionDate = this.courseDetails.assesment_data.second_reviewer_completion_date;
          this.assessmentId = this.courseDetails.assesment_data.assigned_second_reviewer_assessment_id;
          this.assignedAssessmentStatus = this.courseDetails.assesment_data.assigned_second_reviewer_status;
          this.isSearchDisabled = this.courseDetails.assesment_data.assigned_admin_reviewer_status !== 'completed';
          this.canBeReAssigned = !this.courseDetails.assesment_data.is_assigned_second_reviewer;
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    // Admin Reviewer Name:
    this.$nextTick(() => {
      this.updateReviewerData();
    });
  },
  updated() {
  },
  watch: {
    courseDetails() {
      this.updateReviewerData();
    },
  },
};
</script>
